import * as React from "react";
import { ExternalLink, Instagram, Mail, MessageSquare, ShieldAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const contactMethods = [{
  id: "support",
  icon: MessageSquare,
  title: "Korisnička Podrška",
  description: "Imate li pitanja o našim uslugama ili trebate tehničku pomoć?",
  actionText: "Pošaljite upit",
  actionUrl: "/ContactUsPage"
}, {
  id: "instagram",
  icon: Instagram,
  title: "Društvene Mreže",
  description: "Pratite nas za najnovije obavijesti i pravna ažuriranja.",
  actionText: "@MOBILEO_HR",
  actionUrl: "https://www.instagram.com/mobileo_hr"
}];
export default function ContactMethodsGrid() {
  return <section data-section-id="253448" id="kontakt" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container flex flex-col items-center">
        <div className="mb-16 max-w-3xl text-center mx-auto">
          <p className="text-primary mb-4 text-xs font-bold tracking-[0.2em] uppercase">
            Centar za Pomoć
          </p>
          <h2 className="font-default mb-6 text-5xl font-black tracking-tighter md:text-7xl lg:text-8xl">
            <span className="text-foreground block">TU SMO ZA</span>
            <span className="text-secondary block">VAS.</span>
          </h2>
          <p className="text-muted-foreground max-w-xl text-lg leading-relaxed font-default">
            Trebate li pojašnjenje naših uvjeta ili želite prijaviti problem? Odaberite 
            odgovarajući kanal kako bismo vam što brže odgovorili.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 justify-center justify-items-center md:grid-cols-2 lg:grid-cols-4">
          {contactMethods.map((method, index) => {
          const Icon = method.icon;
          return <Card key={method.id} data-index={index} className="bg-card border-border/50 flex h-full flex-col transition-all hover:shadow-lg hover:border-primary/20 rounded-lg">
                <CardHeader className="flex-1 pb-4">
                  <div className="bg-muted mb-6 flex size-12 items-center justify-center rounded-lg">
                    <Icon className="text-primary size-5" />
                  </div>
                  <CardTitle className="font-default mb-3 text-base font-bold tracking-wide uppercase text-foreground">
                    {method.title}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground text-sm leading-relaxed font-default">
                    {method.description}
                  </CardDescription>
                </CardHeader>
                <CardFooter className="pt-0 pb-8">
                  <Button asChild variant="link" className="text-primary hover:text-secondary h-auto p-0 text-xs font-bold tracking-widest uppercase no-underline hover:no-underline transition-colors">
                    <Link to={method.actionUrl} newTab={method.actionUrl.startsWith('http') || method.actionUrl.startsWith('mailto')}>
                      {method.actionText}
                      <ExternalLink className="ml-2 size-3" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}